<template>
    <div>
        <ul class="save">
            <li v-for="item in iconList" :key="item.title">
                <div>
                    <img :src="item.url" alt />
                </div>
                <p>{{item.title}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['iconList']

}
</script>

<style lang="scss" scoped>
@mixin widHei() {
    width: 120px;
    height: 120px;
}
@mixin center() {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.save {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    li {
        width: 120px;
        flex: 1;
        cursor: pointer;
        @include center;
        div {
            @include widHei;
            img {
                @include widHei;
            }
        }
        p {
            font-weight: bold;
            margin-top: 5px;
        }
    }
}
</style>